module.exports = __webpack_public_path__ + "img/sweden-breast-cancer-female.25f454b2.png";